/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { useFirestore } from "../firebase/FirestoreContext";
import { currentProductPrice } from "../functions/currentProductPrice";
import addToCart from "../functions/addToCart";
import "../styles/global.css"; // Import global styles
import ListingPriceFormater from "./ListingPriceFormater";
import { collectionPath, EnvContext } from "../context/EnvContext";
import Cookies from "js-cookie";
import { logAnalyticsEvent } from "../firebase/firebaseConfig";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ShopButton from "./ShopButton";

import PotencyCircles from "./PotencyCircles";
import PriceDisplay from "../elements/ProductPrice";
import ListItem_Ribbon from "./ListItem_Ribbon";
import {
  doc,
  collection,
  query,
  where,
  getDocs,
  deleteDoc,
} from "firebase/firestore";
import cdn from "../utils/cdn";
import isProductAvailable from "../functions/isProductAvailable";
import HeaderContext from "../context/HeaderContext";
import useCart from "../hooks/useCart";

const ProductDetails = ({ brand, name, product, priceInfo, votes, rating }) => {
  return (
    <div
      css={{
        height: "calc(100% - 50px)",
      }}
    >
      <div
        css={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
          paddingBottom: 10,
        }}
      >
        <div css={{}}>
          {brand}
          {name}
        </div>
        {/* Rating */}
        <div css={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
          <div
            css={{
              fontSize: "1rem",
              fontWeight: 400,
              color: "black",
              marginRight: "5px",
            }}
          >
            {rating}
            <span
              css={{
                padding: "0px 3px",
                fontSize: ".8rem",
                bottom: 1,
                position: "relative",
              }}
            >
              ★
            </span>
            <span
              css={{
                fontSize: "1rem",
                fontWeight: 400,
                color: "black",
                paddingLeft: 4,
                position: "relative",
                bottom: 1,
              }}
            >
              ({votes})
            </span>
          </div>
        </div>
        <div
          css={{
            ...styles.addToBag.priceSection,
            fontSize: "1.2rem",
            padding: "8px 0",
          }}
        >
          <ListingPriceFormater
            priceInfo={priceInfo}
            product={product}
            type={"prices"}
          />
        </div>
        <div css={{ ...styles.potency }}>
          Potency
          <PotencyCircles
            value={product?.potency_value}
            containerStyles={{ marginLeft: 5 }}
          />
        </div>
        {/* Key ingredients  */}
        <div css={{ ...styles.keyIngredients }}>
          <div
            css={{
              fontSize: ".9rem",
              fontWeight: 300,
              color: "black",
              marginTop: "5px",
            }}
          >
            Key Ingredients:{" "}
            {product?.key_ingredients || (
              <span css={{ color: "gray" }}>--</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
const AddToCartButton = ({ product, productAvailable, handleAddToCart }) => {
  return (
    <button
      css={{
        ...styles.addToBag.button,
        opacity: !productAvailable ? 0.3 : 1,
        cursor: !productAvailable ? "not-allowed" : "pointer",
      }}
      onClick={(e) => {
        e.stopPropagation();
        productAvailable && handleAddToCart(product.seller_product_id);
      }}
    >
      <AddIcon css={{ fontSize: 24, fontWeight: 800 }} />
    </button>
  );
};

const HorizontalQuantityActions = ({
  product,
  isAdding,
  quantity,
  handleDecreaseQuantity,
  handleAddToCart,
  increaseQuantity,
  handleRemoveFromCart,
}) => {
  return (
    <div>
      {isProductAvailable(product) ? (
        <div>
          {quantity === 0 ? (
            <ShopButton
              text={isAdding ? "Adding..." : "Add to order"}
              background={isAdding ? "#a0a0a0" : "#007aff"} // Gray if loading
              arrow={false}
              textColor="white"
              padding="10px 10px"
              containerStyles={{ width: "100%" }}
              buttonStyle={{
                margin: "10px 0 0 0",
                opacity: isAdding ? 0.5 : 1,
              }}
              disabled={isAdding}
              onClick={(e) => {
                e.stopPropagation();
                if (!isAdding) {
                  handleAddToCart(product.seller_product_id);
                }
              }}
            />
          ) : (
            <div
              css={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #007aff",
                borderRadius: "20px",
                padding: "0px 10px",
                width: "100%",
                maxWidth: "600px",
                justifyContent: "space-between",
                margin: "10px 0",
                height: 38,
              }}
            >
              {quantity === 1 ? (
                <button
                  css={{
                    ...styles.addToBag.button,
                    cursor: "pointer",
                    padding: "0px 5px 0 5px",
                    display: "flex",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveFromCart(product.seller_product_id);
                  }}
                >
                  <DeleteOutlineIcon
                    css={{ fontSize: "1.1rem", position: "relative" }}
                  />
                </button>
              ) : (
                <button
                  css={{
                    ...styles.addToBag.button,
                    cursor: "pointer",
                    fontWeight: "bold",
                    fontSize: "18px",
                    padding: "0px 5px",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDecreaseQuantity(product.seller_product_id);
                  }}
                >
                  –
                </button>
              )}
              <div css={{ fontWeight: "bold" }}>{quantity}</div>
              <button
                css={{
                  ...styles.addToBag.button,
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "18px",
                  padding: "0px 5px",
                  opacity:
                    product?.listing_stock_amount <= quantity ||
                    (product?.sooperdeal_limit_per_order &&
                      quantity >= product.sooperdeal_limit_per_order)
                      ? 0.3
                      : 1,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  increaseQuantity(product.seller_product_id);
                }}
              >
                +
              </button>
            </div>
          )}
        </div>
      ) : (
        <ShopButton
          text={"Out of stock"}
          background={"#f0f0f0"}
          arrow={false}
          textColor={"black"}
          padding={"10px 10px"}
          containerStyles={{ width: "100%" }}
          buttonStyle={{ margin: "10px 0 0 0" }}
        />
      )}
    </div>
  );
};

const QuantityActions = ({
  isExpanded,
  product,
  cart,
  productAvailable,
  handleAddToCart,
  handleDecreaseQuantity,
  handleExpandCartButton,
}) => {
  return (
    <div css={{ display: "flex", alignItems: "center" }}>
      {isExpanded ? (
        cart.find(
          (item) => item.seller_product_id === product.seller_product_id,
        )?.quantity === 1 ? (
          <>
            <button
              css={{ ...styles.addToBag.button }}
              onClick={(e) => {
                e.stopPropagation();
                handleDecreaseQuantity(product.seller_product_id);
              }}
            >
              <DeleteOutlineIcon css={{ fontSize: 16, fontWeight: 800 }} />
            </button>
            <div css={styles.addToBag.quantity}>
              {
                cart.find(
                  (item) =>
                    item.seller_product_id === product.seller_product_id,
                ).quantity
              }
            </div>
            <button
              css={{
                ...styles.addToBag.button,
                opacity: !productAvailable ? 0.3 : 1,
              }}
              onClick={(e) => {
                e.stopPropagation();
                productAvailable && handleAddToCart(product.seller_product_id);
              }}
            >
              <AddIcon css={{ fontSize: 24, fontWeight: 800 }} />
            </button>
          </>
        ) : (
          <>
            <button
              css={{ ...styles.addToBag.button }}
              onClick={(e) => {
                e.stopPropagation();
                handleDecreaseQuantity(product.seller_product_id);
              }}
            >
              <RemoveIcon css={{ fontSize: 16, fontWeight: 800 }} />
            </button>
            <div css={styles.addToBag.quantity}>
              {
                cart.find(
                  (item) =>
                    item.seller_product_id === product.seller_product_id,
                ).quantity
              }
            </div>
            <button
              css={{
                ...styles.addToBag.button,
                opacity: !productAvailable ? 0.3 : 1,
              }}
              onClick={(e) => {
                e.stopPropagation();
                productAvailable && handleAddToCart(product.seller_product_id);
              }}
            >
              <AddIcon css={{ fontSize: 24, fontWeight: 800 }} />
            </button>
          </>
        )
      ) : (
        <button
          css={styles.addToBag.quantity}
          onClick={(e) => {
            e.stopPropagation();
            handleExpandCartButton();
          }}
        >
          {
            cart.find(
              (item) => item.seller_product_id === product.seller_product_id,
            ).quantity
          }
        </button>
      )}
    </div>
  );
};
const Image = ({ product, productAvailable, displayType }) => {
  return (
    <img
      src={
        product?.images?.length > 0
          ? cdn.image(product.images[0], { w: 500, h: 500 })
          : "/images/no_product_image.png"
      }
      width={260}
      height={260}
      alt={product?.name || "Product"}
      css={{
        ...styles.listItemImage,
        opacity: !productAvailable ? 0.6 : 1,
        objectFit: displayType === "vertical" ? "cover" : "contain",
        filter: !productAvailable ? "grayscale(100%)" : "none",
      }}
      loading="lazy"
      onError={(e) => {
        e.target.src = "/images/no_product_image.png"; // Fallback if image fails
      }}
    />
  );
};

const ListItem = ({
  product,
  displayType = "vertical",
  priceTheme,
  ribbonSettings,
}) => {
  const environment = useContext(EnvContext);
  const { cartItems, refresh } = useCart();
  const { showHeader, pulseCart } = useContext(HeaderContext);
  const navigate = useNavigate();
  const firestore = useFirestore();
  const auth = getAuth();
  const user = auth.currentUser;
  const [priceInfo, setPriceInfo] = useState({});
  //
  const [isExpanded, setIsExpanded] = useState(false);
  const shrinkTimeoutRef = useRef(null);
  const [quantity, setQuantity] = useState(0);
  const [isAdding, setIsAdding] = useState(false);
  const productAvailable = isProductAvailable(product);

  // Fetch the price information when the component mounts
  useEffect(() => {
    const fetchPriceInfo = async () => {
      const result = await currentProductPrice(product);
      setPriceInfo(result); // Store the result in the state
    };

    fetchPriceInfo();
  }, [product]); // Dependency on the product, so it runs when the product changes

  useEffect(() => {
    const existingCartItem = cartItems.find(
      (item) => item.seller_product_id === product.seller_product_id,
    );
    setQuantity(existingCartItem ? existingCartItem.quantity : 0);
  }, [cartItems, product.seller_product_id]);

  const handleAddToCart = async (listingID) => {
    showHeader();
    setIsAdding(true); // <--- Start loading
    try {
      await addToCart(
        listingID,
        auth.currentUser,
        firestore,
        1,
        collectionPath,
      );
      pulseCart();
    } catch (error) {
      console.error("Error updating cart in database:", error);
      // Revert your optimistic update if necessary
    } finally {
      refresh();
      setIsAdding(false); // <--- Done loading
    }
  };

  //
  const increaseQuantity = async (listingID) => {
    showHeader();
    if (
      product?.sooperdeal_limit_per_order &&
      quantity >= product.sooperdeal_limit_per_order
    ) {
      alert(
        `You reached the maximum limit of ${product.sooperdeal_limit_per_order}.`,
      );
      return;
    }

    if (quantity >= product.listing_stock_amount) {
      alert(`Only ${product.listing_stock_amount} items available in stock.`);
      return;
    }

    await addToCart(listingID, user, firestore, 1, collectionPath);
    pulseCart();
    setQuantity(quantity + 1);
    refresh();
  };

  const handleRemoveFromCart = async (listingID) => {
    if (!user) return;
    showHeader();

    const cartQuery = query(
      collection(firestore, `${collectionPath}Carts/CartsList/DataBase`),
      where("user_id", "==", user.uid),
      where("status", "==", "ordering"),
    );
    const cartSnap = await getDocs(cartQuery);

    if (!cartSnap.empty) {
      const cartID = cartSnap.docs[0]?.id;
      const itemRef = doc(
        firestore,
        `${collectionPath}Carts/CartsList/DataBase/${cartID}/Items`,
        listingID,
      );
      await deleteDoc(itemRef);
      pulseCart();
      setQuantity(0);
    }
    refresh();
  };

  // Handle tapping outside to shrink button
  const handleClickOutside = (event) => {
    if (!event.target.closest(".cart-button-container")) {
      setIsExpanded(false); // Close all when clicking outside
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
      if (shrinkTimeoutRef.current) {
        clearTimeout(shrinkTimeoutRef.current);
      }
    };
  }, []);

  const handleExpandCartButton = () => {
    setIsExpanded(false); // Close all before opening a new one
    setTimeout(() => {
      setIsExpanded(true);
    }, 10); // Delay ensures previous state is cleared first

    if (shrinkTimeoutRef.current) {
      clearTimeout(shrinkTimeoutRef.current);
    }
    shrinkTimeoutRef.current = setTimeout(() => {
      setIsExpanded(false);
    }, 3000);
  };

  const handleDecreaseQuantity = async (listingID) => {
    showHeader();
    try {
      await addToCart(
        listingID,
        auth.currentUser,
        firestore,
        -1,
        collectionPath,
      );
      refresh();
      pulseCart();
    } catch (error) {
      console.error("Error decreasing cart quantity: ", error);
    }
  };

  const saveScrollPosition = () => {
    const scrollY = window.scrollY; // Get the current Y scroll position
    Cookies.set("ShopPageScrollPosition", scrollY); // Save it in localStorage
  };

  const handleNavigate = () => {
    //
    logAnalyticsEvent("select_content", {
      content_type: "product",
      item_id: product.seller_product_id,
      item_name: product.product_name,
      environment: environment,
    });
    //
    saveScrollPosition(); // Save scroll position before navigating
    navigate(`/Listing/${product?.seller_product_id}`); // Navigate to the product detail page
  };

  // calculate rating and initial rating
  let rating = parseFloat(product?.rating?.rating) || 0;
  let votes = parseFloat(product?.rating?.votes) || 0;
  let initialRating = parseFloat(product?.rating_initial?.rating) || 0;
  let initialVoting = parseFloat(product?.rating_initial?.voting) || 0;

  // if all is 0
  if (votes === 0 && initialVoting === 0) {
    rating = initialRating;
    votes = initialVoting;
  } else {
    rating = parseFloat(
      (rating + initialRating * initialVoting) / (initialVoting + votes),
    ).toFixed(1);
    votes = votes + initialVoting;
  }

  const renderBrand = (
    <div style={{ ...styles.productBrand }}>{product?.brand_name}</div>
  );

  const renderName = (
    <h3
      style={{
        ...styles.productName,
        // max two lines
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        padding: 0,
      }}
    >
      {product?.product_name || ""}
    </h3>
  );

  return (
    <div
      css={{
        ...styles.listItemContainer,
        opacity: !productAvailable ? 0.8 : 1,
      }}
    >
      <div
        css={{
          ...styles.listItem,
          position: "relative",
          height: "100%",
          padding: "5px 0",
        }}
        onClick={() => {
          handleNavigate();
        }}
      >
        <div
          css={{
            display: "flex",
            flexDirection: displayType === "vertical" ? "column" : "row",
            justifyContent:
              displayType === "vertical" ? "space-between" : "flex-start",
            alignItems: displayType === "vertical" ? "flex-start" : "",
            position: "relative",
            border: displayType === "vertical" ? "none" : "1px solid #f0f0f0",
            borderRadius: displayType === "vertical" ? "0px" : "8px",
            margin: displayType === "vertical" ? "0px" : "0px 10px 10px 10px",
            height: "100%",
          }}
        >
          {displayType === "vertical" && (
            <ListItem_Ribbon
              product={product}
              priceInfo={priceInfo}
              ribbonSettings={ribbonSettings}
            />
          )}

          <div
            css={{
              display: "flex",
              flex: 1,
              marginBottom: displayType === "vertical" ? "10px" : 0,
              height: "100% !important",
            }}
          >
            <div
              css={{
                ...styles.listItemImageContainer,
                borderRadius:
                  displayType === "vertical" ? "8px" : "8px 0px 0px 8px",
                justifyContent: "center",
                flex: displayType === "vertical" ? "" : "0 1 40%", // flex-grow: 0, flex-shrink: 1, flex-basis: 40%
                boxSizing: "border-box",
              }}
            >
              {displayType !== "vertical" && (
                <ListItem_Ribbon
                  product={product}
                  priceInfo={priceInfo}
                  ribbonSettings={ribbonSettings}
                />
              )}
              <Image
                product={product}
                productAvailable={productAvailable}
                displayType={displayType}
              />

              {/* Add to bag section */}
              <div
                className="cart-button-container"
                css={{
                  ...styles.addToBag.container,
                  width: isExpanded ? "100px" : "40px",
                  transition: "width 0.3s ease", // Add smooth transition
                  display: displayType === "vertical" ? "flex" : "none",
                }}
              >
                {cartItems.some(
                  (item) =>
                    item.seller_product_id === product.seller_product_id,
                ) ? (
                  <QuantityActions
                    isExpanded={isExpanded}
                    product={product}
                    cart={cartItems}
                    productAvailable={productAvailable}
                    handleAddToCart={handleAddToCart}
                    handleDecreaseQuantity={handleDecreaseQuantity}
                    handleExpandCartButton={handleExpandCartButton}
                  />
                ) : (
                  <AddToCartButton
                    product={product}
                    productAvailable={productAvailable}
                    handleAddToCart={handleAddToCart}
                  />
                )}
              </div>
            </div>
          </div>
          <div
            css={{
              ...styles.listItemContent,
              flex: "0 1 60%", // flex-grow: 0, flex-shrink: 1, flex-basis: 60%
              minWidth: 0,
              boxSizing: "border-box",
              display: "flex",
              flexDirection: "column",
              height: "100%",
              padding: displayType === "vertical" ? "0px 5px" : "10px",
            }}
          >
            <div
              css={{
                ...styles.productPrice,
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: displayType === "vertical" ? "column" : "row",
              }}
            >
              {displayType === "vertical" ? (
                <>
                  <div css={{ ...styles.addToBag.priceSection, padding: 0 }}>
                    {priceInfo ? (
                      <PriceDisplay
                        priceInfo={priceInfo}
                        priceTheme={priceTheme}
                      />
                    ) : null}
                  </div>
                  {renderBrand}
                  {renderName}
                </>
              ) : (
                <div css={{ height: "100%" }}>
                  <ProductDetails
                    product={product}
                    brand={renderBrand}
                    name={renderName}
                    priceInfo={priceInfo}
                    votes={votes}
                    rating={rating}
                  />
                  <HorizontalQuantityActions
                    product={product}
                    isAdding={isAdding}
                    quantity={quantity}
                    handleAddToCart={handleAddToCart}
                    handleDecreaseQuantity={handleDecreaseQuantity}
                    increaseQuantity={increaseQuantity}
                    handleRemoveFromCart={handleRemoveFromCart}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Styles object for ListItem component
const styles = {
  listItemContainer: {
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    cursor: "pointer",
  },
  listItemImageContainer: {
    position: "relative",
    width: "100%",
    background: "#f5f5f5",
    minWidth: "150px",
    minHeight: "150px",
    flexGrow: 1,
  },
  listItemImage: {
    display: "flex",
    objectFit: "contain",
    width: "100%",
    height: "100%",
    aspectRatio: "1 / 1",
  },
  listItemContent: {
    display: "flex",
    flexDirection: "column",
    minWidth: "100px",
  },
  productPrice: {
    color: "black",
    fontWeight: "700",
    fontSize: "1rem",
  },
  productBrand: {
    fontSize: ".9rem",
    fontWeight: "800",
    color: "black",
    marginBottom: "2px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 1,
    WebkitBoxOrient: "vertical",
  },
  productName: {
    fontSize: ".9rem",
    fontWeight: "300",
    color: "black",
    marginTop: "2px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },
  /* Add to bag section */
  addToBag: {
    container: {
      position: "absolute",
      right: 0,
      marginBottom: "5px",
      marginRight: "5px",
      display: "flex",
      alignSelf: "flex-end",
      justifyContent: "center",
      alignContent: "center",
      alignItems: "center",
      textAlign: "center",
      fontSize: "15px",
      fontWeight: 800,
      backgroundColor: "white",
      borderRadius: "40px",
      border: "1px solid silver",
      height: "40px",
      boxShadow: "0 5px 5px rgba(0,0,0,.1)",
      transition: "width 0.3s ease, border-radius 0.3s ease, height 0.3s ease",
    },
    priceSection: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      paddingLeft: "10px",
    },
    priceOffer: {
      display: "flex",
      alignItems: "flex-start",
      flexDirection: "column",
      fontWeight: 700,
    },
    originalPrice: {
      color: "gray",
      fontSize: "12px",
      textDecoration: "line-through",
      marginRight: "5px",
    },
    salePrice: {
      color: "black",
      fontWeight: 700,
    },
    price: {
      color: "#06ca49",
      fontWeight: 700,
    },
    button: {
      display: "flex",
      justifyContent: "center",
      padding: "0px 5px",
      transition: "background-color 0.3s ease",
      border: "none",
      background: "none",
    },
    quantity: {
      border: "none",
      background: "none",
      flex: 1,
      padding: "3px 10px",
      fontSize: "18px",
      transition: "background-color 0.3s ease",
    },
    addedToCart: {
      backgroundColor: "#000",
      color: "white",
    },
  },
  offerRibon: {
    position: "absolute",
    top: 15,
    left: 15,
    padding: "4px 5px",
    backgroundColor: "#ff0000",
    color: "white",
    fontWeight: 600,
    fontSize: "12px",
    zIndex: 1,
    borderRadius: 6,
    // shadow
    boxShadow: "1px 1px 4px rgba(0,0,0,.3)",
  },
  potency: {
    display: "flex",
    flexDirection: "row",
    fontSize: ".9rem",
    fontWeight: 300,
    alignItems: "center",
    textAlign: "left",
  },
  keyIngredients: {
    display: "flex",
    flexDirection: "column",
  },
  likeShare: {
    container: {
      padding: "20px 10px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-end",
    },
    likeButton: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      cursor: "pointer",
      padding: 3,
    },
    shareButton: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      cursor: "pointer",
      padding: 3,
    },
    icon: {
      color: "black",
      marginRight: "5px",
      fontSize: "16px",
    },
  },
};

export default ListItem;
